<template>
    <CFooter>
      <div class="d-flex w-100">
        <div class="col-sm-9">
          <i class="bi bi-gift mr-2" @click="goToUsers()" v-if="$store.state.user.data.tipo_Empleado === 'A'"></i>
          <span class="small">
            <strong>Uchuva &#127816;</strong> Ver. <strong>{{ version }}</strong>
          </span>
          <span class="small ml-2">
            <strong>Compilaci&oacute;n:</strong> {{ fechaCompilacion }}
          </span>
          <span class="small ml-2"><strong>Servidor</strong>: {{ $store.state.user.data.servidor }}</span>
        </div>
        <div class="col-sm-3">
          <div class="float-right">
            <span class="small mr-1">Hecho con &#x1F496; por</span>
            <a :href=url_sicya class="small" target="_blank">&copy; SICyA Software</a>
          </div>
        </div>
      </div>
    </CFooter>
</template>

<script>
  import { version } from "../../../package.json";
  import CONSTANTS from "@/constants";
  
  export default {
    name: "Footer",
    data() {
      return {
        version: version,
        fechaCompilacion: "",
        rootPath: "",
        url_sicya: "https://sicya.blogspot.com/"
      }
    },
    methods: {
      goToUsers() {
        this.$router.push({
          path: "/administracion/ayudas/acerca/usuarios"
        })
      }
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;
      this.fechaCompilacion = CONSTANTS.build;

      console.log(this.$store.state.user.data.servidor);
      
    }
  }
</script>
